import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import { AnimatedTab } from '../../components/animation/AnimatedTab';
import { CheckText } from '../../components/common/CheckText';
import { Hub } from '../../components/common/Hub/Hub';
import Spinner from '../../components/common/Spinner';
import { getUserTickets } from '../../slices/auth-slice';
import { H3, P1 } from '../../styles/FontStyles';
import { Button, Flexed, PageTitle } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { MergedPackageModel } from './Maeketplace.types';
import { getMarketplace } from './Marketplace.actions';
import { StakingHubDetailsStyled } from './Marketplace.styled';
import { PurchasePackageAndCombo } from './PurchasePackageAndCombo/PurchasePackageAndCombo';

export const Marketplace = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('marketplace');
  const { loading, hubs } = useAppSelector((state) => state.marketplace);

  useEffect(() => {
    dispatch(getMarketplace());
    dispatch(getUserTickets());
  }, [dispatch]);

  const [selectedHub, setSelectedHub] = useState(hubs?.[0] || null);
  const [modal, setModal] = useState(false);

  const handleSeeDetails = (hub: any) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub: any) => {
    setModal(true);
    handleSeeDetails(hub);
  };

  useEffect(() => {
    setSelectedHub(hubs?.[0]);
  }, [hubs]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'marketplace'}>
      <PageTitle>{t('staking_hub_nft_marketplace')}</PageTitle>

      <P1 mb='50'>{t('join_a_community')}</P1>

      <Flexed rowSM gap={selectedHub !== null ? '100px' : '0'}>
        <Flexed
          column
          width={selectedHub !== null ? '65%' : '100%'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          {hubs?.map((hub) => {
            const { id, image, title, price, weeklyCap } = hub;
            if (id <= 34) {
              return (
                <Hub
                  key={id}
                  image={image}
                  title={title}
                  price={price}
                  onClick={() => handleSeeDetails(hub)}
                  selected={selectedHub?.id === id}
                  button={
                    <Button
                      w='150px'
                      wSM='100%'
                      onClick={() => handleSelectPackage(hub)}
                      negative={selectedHub?.id !== id}>
                      {t('select_this_hub')}
                    </Button>
                  }
                  weeklyCap={weeklyCap}
                  stakingHubDetails={<StakingHubDetails hub={hub} />}
                />
              );
            }
          })}
        </Flexed>
        <Flexed
          desktop
          column
          width={selectedHub !== null ? '35%' : '0'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          <div
            style={{
              position: 'sticky',
              top: 200
            }}>
            <AnimatePresence exitBeforeEnter>
              {selectedHub?.id &&
                hubs?.map((hub, i) => {
                  if (hub?.id === selectedHub?.id) {
                    return (
                      <AnimatedTab key={i}>
                        <H3 mb='4' color={color.colors.primary900}>
                          {hub?.name}
                        </H3>
                        <StakingHubDetailsStyled>
                          <StakingHubDetails hub={hub} />
                        </StakingHubDetailsStyled>
                      </AnimatedTab>
                    );
                  } else return null;
                })}
            </AnimatePresence>
          </div>
        </Flexed>
      </Flexed>
      {/* <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      /> */}
    </AnimatedDashboard>
  );
};

const StakingHubDetails = ({ hub }: { hub: MergedPackageModel }) => {
  const { t } = useTranslation('marketplace');

  return (
    <div>
      <P1 semiBold color={color.colors.neutral500} mb='12'>
        {t('staking_hub_details')}
      </P1>
      {hub?.benefits?.map((benefit, i) => (
        <div key={i}>
          <CheckText text={benefit.text} />
        </div>
      ))}

      <P1 semiBold color={color.colors.neutral500} mb='12'>
        {t('bonuses')}
      </P1>

      {hub?.bonuses?.map((benefit, i) => (
        <div key={i}>
          <CheckText text={benefit.text} />
        </div>
      ))}
    </div>
  );
};
